

export default getStandaloneModule;

import { parse } from 'acorn';
import MagicString from 'magic-string';
import annotateAst from 'utils/ast/annotate';
import findImportsAndExports from 'utils/ast/findImportsAndExports';
import getUnscopedNames from 'utils/ast/getUnscopedNames';
import disallowConflictingImports from '../utils/disallowConflictingImports';
import hasOwnProp from 'utils/hasOwnProp';
import { default as sanitize, splitPath } from 'utils/sanitize';

var SOURCEMAPPINGURL_REGEX = /^# sourceMappingURL=/;
function getStandaloneModule(options) {
	var code = undefined,
	    ast = undefined;

	if (typeof options.source === 'object') {
		code = options.source.code;
		ast = options.source.ast;
	} else {
		code = options.source;
	}

	var toRemove = [];
	var comments = [];

	var mod = {
		body: new MagicString(code),
		ast: ast || parse(code, {
			ecmaVersion: 6,
			sourceType: 'module',
			onComment: function (block, text, start, end) {
				// sourceMappingURL comments should be removed
				if (!block && SOURCEMAPPINGURL_REGEX.test(text)) {
					toRemove.push({ start: start, end: end });
				} else {
					comments.push({ start: start, end: end });
				}
			}
		})
	};

	toRemove.forEach(function (_ref) {
		var start = _ref.start;
		var end = _ref.end;
		return mod.body.remove(start, end);
	});

	var _findImportsAndExports = findImportsAndExports(mod.ast, code, comments);

	var imports = _findImportsAndExports.imports;
	var exports = _findImportsAndExports.exports;
	var defaultExport = _findImportsAndExports.defaultExport;

	disallowConflictingImports(imports);

	mod.imports = imports;
	mod.exports = exports;
	mod.defaultExport = defaultExport;

	var conflicts = {};

	if (options.strict) {
		annotateAst(mod.ast, {
			trackAssignments: null
		});

		// TODO there's probably an easier way to get this array
		Object.keys(mod.ast._declared).concat(getUnscopedNames(mod)).forEach(function (n) {
			conflicts[n] = true;
		});
	}

	determineImportNames(imports, options.getModuleName, conflicts);

	return mod;
}

function determineImportNames(imports, userFn, usedNames) {
	var nameById = {};
	var inferredNames = {};

	imports.forEach(function (x) {
		var moduleId = x.path;
		var name = undefined;

		moduleId = x.path;

		// use existing value
		if (hasOwnProp.call(nameById, moduleId)) {
			x.name = nameById[moduleId];
			return;
		}

		// if user supplied a function, defer to it
		if (userFn && (name = userFn(moduleId))) {
			name = sanitize(name);

			if (hasOwnProp.call(usedNames, name)) {
				// TODO write a test for this
				throw new Error('Naming collision: module ' + moduleId + ' cannot be called ' + name);
			}
		} else {
			var parts = splitPath(moduleId);
			var i = undefined;
			var prefix = '';
			var candidate = undefined;

			do {
				i = parts.length;
				while (i-- > 0) {
					candidate = prefix + sanitize(parts.slice(i).join('__'));

					if (!hasOwnProp.call(usedNames, candidate)) {
						name = candidate;
						break;
					}
				}

				prefix += '_';
			} while (!name);
		}

		usedNames[name] = true;
		nameById[moduleId] = name;

		x.name = name;
	});

	// use inferred names for default imports, wherever they
	// don't clash with path-based names
	imports.forEach(function (x) {
		if (x.as && !hasOwnProp.call(usedNames, x.as)) {
			inferredNames[x.path] = x.as;
		}
	});

	imports.forEach(function (x) {
		if (hasOwnProp.call(inferredNames, x.path)) {
			x.name = inferredNames[x.path];
		}
	});
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/standalone/getModule.js.01-babel.map